/* eslint-disable no-confusing-arrow */
const { recommendRandomSort, formatImage, formatUrl } = require('@ifeng/public_method');

module.exports = {
    jsonParse: data => {
        return JSON.parse(data);
    },
    handleAreaAd: data => {
        return data === '0' ? '' : data;
    },
    handleInfoAd: data => {
        return data.map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 145, 80) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleRecommend: data => {
        return data.map(item => ({
            base62Id: item.base62Id,
            url: formatUrl(item.url),
            title: item.title,
            commentUrl: item.commentUrl,
            newsTime: item.newsTime,
        }));
    },
    handlePicAndVideo: data => {
        return data.map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 165, 100) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleNewsList: data => {
        return data.map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 132, 155) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleUnfoldTypeData: data => {
        try {
            return {
                articleUnfold: (data && data.articleUnfold) || '1',
                articleShareUnfold: (data && data.articleShareUnfold) || '1',
                stopReadArticle: (data && data.stopReadArticle) || [],
                guideLayer: (data && data.guideLayer) || '2',
                videoShareUnfold: (data && data.videoShareUnfold) || '1',
                topicPopup: (data && data.videoShareUnfold) || '1',
            };
        } catch (e) {
            console.error(e);
        }
    },
    handleFixedIconData: data => {
        try {
            return {
                image: (data && data.image) || '',
                link: (data && data.link) || '',
                clientLink: (data && data.clientLink) || '',
                topic: (data && data.topic) || '4',
                video: (data && data.video) || '4',
                article: (data && data.article) || '4',
            };
        } catch (e) {
            console.error(e);
        }
    },
    handleGoodbookData: data => {
        return recommendRandomSort(data, 8).map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 100, 56) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleArticleData: data => {
        return data.slice(0, 3).map(item => ({
            type: 'recommend',
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 100, 56) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleFoVideoData: data => {
        return data.slice(0, 10).map(item => ({
            type: 'recommend',
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 100, 56) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleVideoData: data => {
        return data.slice(0, 3).map(item => ({
            type: 'recommend',
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 100, 56) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleWutonghuiContent: data => {
        return data.slice(0, 2).map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 140, 80) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleSubjectData: data => {
        return data.slice(0, 5).map(
            (item, index) =>
                index === 0
                    ? {
                          img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 270, 105) : '',
                          url: formatUrl(item.url),
                          title: item.title,
                      }
                    : {
                          url: formatUrl(item.url),
                          title: item.title,
                      },
        );
    },
};
